import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import LoadingScreen from './LoadingScreen';
import toast from 'react-hot-toast';

const LicenseGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuthStore();
  const [loading, setLoading] = useState(true);
  const [hasLicenses, setHasLicenses] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkLicenses = async () => {
      if (!user?.email) {
        setLoading(false);
        return;
      }

      try {
        const response = await fetch('https://services.shopiweb.fr/api/licenses/get_by_email/premium', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams({ email: user.email }).toString()
        });

        if (response.ok) {
          const data = await response.json();
          const premiumLicenses = data.user?.nbAuthorizedLicenseType?.premium || 0;
          setHasLicenses(premiumLicenses > 0);
        } else {
          setHasLicenses(false);
        }
      } catch (error) {
        console.error('Error checking licenses:', error);
        setHasLicenses(false);
        toast.error('Erreur lors de la vérification des licences');
      } finally {
        setLoading(false);
      }
    };

    checkLicenses();
  }, [user?.email]);

  if (loading) {
    return <LoadingScreen />;
  }

  if (!hasLicenses) {
    toast.error('Vous devez avoir au moins une licence Premium pour accéder à cette page');
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default LicenseGuard;